// extracted by mini-css-extract-plugin
export default {"chip":"styles-module--chip--Oteya","chipSVG":"styles-module--chipSVG--xYSVz","chipsRow":"styles-module--chipsRow--8qlLO","overflowArrow":"styles-module--overflowArrow--gOZIY"};